<template>
<div>
    <Box  @close="close(false)">
        <template #top>Nueva Transferencia: Entre Almacenes</template>
        <template #center>
            <div class="nj-panel">
                <div class="nj-panel-content">
                    <div class="nj-grid">
                        <InputSelect label="Almacen origen" v-model="transferencia_items.alm_origen" id="ta-almacenes-origen" :source="almacenes_origen" itemKey="alm_id" itemValue="alm_id"
                            :filterFunction="filterAlmacen" :labelFunction="labelAlmacen">
                            <template #default="data">
                                {{ labelAlmacen(data.item) }}
                            </template>
                        </InputSelect>
                        <InputSelect label="Almacen destino" v-model="transferencia_items.alm_destino" id="ta-almacenes-destino" :source="almacenes_origen" itemKey="alm_id" itemValue="alm_id"
                            :filterFunction="filterAlmacen" :labelFunction="labelAlmacen">
                            <template #default="data">
                                {{ labelAlmacen(data.item) }}
                            </template>
                        </InputSelect>
                        <InputText label="Guía de remisión" v-model="transferencia_items.tfi_guia_remision"></InputText>
                        <InputDate label="Fecha de llegada" v-model="transferencia_items.tfi_fecha_estimada_llegada_date"></InputDate>
                    </div>
                    <br>
                    <SearchBox label="Item" id="ta-items" itemKey="prv_id" :source="productos" :labelFunction="(item) => item.prv_nombre" :searchFunction="buscarItems" @selectItem="agregarProducto">
                        <template #default="data">
                            <div class="nj-grid">
                                <span>{{ `${data.item.prv_nombre} (stock: ${data.item.pal_stock})` }}</span>
                            </div>
                        </template>
                    </SearchBox>
                    <br>
                    <b-table :data="transferencia_items.lista_transferencia_items_detalle" sort-icon="arrow-up" sort-icon-size="is-small">
                        <template slot-scope="props">
                            <b-table-column label="Producto" header-class="is-info">{{ props.row.prv_nombre }}</b-table-column>
                            <b-table-column label="Stock" header-class="is-info" style="width: 100px;">{{ props.row.pal_stock }}</b-table-column>
                            <b-table-column label="Cantidad" header-class="is-info" style="width: 100px;">
                                <input type="text" class="nj-text" v-model="props.row.tid_cantidad">
                            </b-table-column>
                            <b-table-column label="Opciones" header-class="is-info" style="width: 72px;">
                                <Button title="Retirar" icon="remove" color="red" @click="retirarProducto(props.row.prv_id)"></Button>
                            </b-table-column>
                        </template>
                    </b-table>
                </div>
            </div>
        </template>
        <template #bottom>
            <Button icon="save" label="Registrar" @click="registrar()"></Button>
        </template>
    </Box>
</div>
</template>

<script>
import { ProductoAlmacenService, ResponseStatus, TransferenciaItemsService, UsuarioService } from "../../rest"
import { Acceso, Data, DateTime, Validator } from "../../util"
import Toast from "../../util/toast"
import { Box, Button, InputDate, InputSelect, InputText, SearchBox } from "../components"

export default {
    name: "TransferenciaEntreAlmacenes",
    components: {
        Box,
        Button,
        InputSelect,
        SearchBox,
        InputText,
        InputDate,
    },
    data() {
        return {
            transferencia_items: {
                tfi_usu_registrador: UsuarioService.getUsuario().usu_id,
                tfi_tipo: 2, // transferencia: compra externa
                tfi_fecha_estimada_llegada: null,
                tfi_fecha_estimada_llegada_date: null,
                alm_origen: null,
                alm_destino: null,
                lista_transferencia_items_detalle: []
            },
            productos: [],
            almacenes_origen: [],
            almacenes_destino: [],
        }
    },
    methods: {
        registrar() {
            if (
                Validator.start(
                    this.transferencia_items.alm_origen,
                    this.transferencia_items.alm_destino,
                    this.transferencia_items.lista_transferencia_items_detalle,
                    this.transferencia_items.tfi_fecha_estimada_llegada_date,
                )
            ) {
                TransferenciaItemsService.registrar(this.transferencia_items).then(
                    response => {
                        if (ResponseStatus.isSuccess(response)) {
                            Toast.success(response.message)
                            this.close(true)
                        }
                        if (ResponseStatus.isError(response)) {
                            Toast.warn(response.message)
                        }
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
            }
            else {
                Toast.warn("Falta ingresar algunos datos para registrar la transferencia")
            }
        },
        close(buscar) {
            this.$emit("close", {
                interfaz: "TransferenciaEntreAlmacenes",
                activar: false,
                buscar
            })
        },
        buscarItems(prv_nombre) {
            ProductoAlmacenService
                .buscarRapido({
                    producto_almacen: {
                        prv_nombre,
                        alm_id: this.transferencia_items.alm_origen
                    }
                })
                .then(response => {
                    this.productos = response.data
                })
                .catch(error => {
                    Toast.error(error)
                    
                })
        },
        filterAlmacen(items, param) {
            if (param != null && param != "") {
                return items.filter(item => `${item.pry_nombre} | ${item.alm_nombre}`.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        labelAlmacen(item) {
            return `${item.pry_nombre} | ${item.alm_nombre} ${item.alm_tipo == 0 ? "*" : ""}`
        },
        agregarProducto(item) {
            const prod = this.transferencia_items.lista_transferencia_items_detalle.find(i => i.prv_id == item.prv_id)
            if (!prod) {
                this.transferencia_items.lista_transferencia_items_detalle.push({
                    prv_id: item.prv_id,
                    prv_nombre: item.prv_nombre,
                    tid_cantidad: 1,
                    pal_stock: item.pal_stock
                })
            }
            else {
                Toast.warn("El producto ya ha sido agregado")
            }
        },
        retirarProducto(prv_id) {
            this.transferencia_items.lista_transferencia_items_detalle = this.transferencia_items.lista_transferencia_items_detalle.filter(i => i.prv_id != prv_id)
        },
    },
    mounted() {
        this.transferencia_items.tfi_fecha_estimada_llegada_date = DateTime.todayString()
        this.almacenes_origen = Data.getAlmacenes()
        this.almacenes_destino = Data.getAlmacenes()
    }
}
</script>

<style scoped></style>